import { useMutation } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type {
    ScoringConfigRule,
    ScoringConfigType,
} from "app/pages/sales-intelligence/sub-modules/signals/types/scoring-config";

import { leadScoringAgentQueryKeys } from "../key-factory/factory";

export const DEFAULT_SCORING_CONFIG_ERROR_KEY = "si.score_settings.save.error";

type UpdateScoringConfigVariables = {
    rules: ScoringConfigRule;
    /**
     * i18n key used as the leading part of the failure message (e.g. "Can not delete scoring rule.").
     * The server-provided reason is appended when available. Defaults to the generic save error.
     */
    errorPrefixKey?: string;
};

const useUpdateScoringConfigMutation = (configType: ScoringConfigType) => {
    return useMutation({
        mutationKey: leadScoringAgentQueryKeys.configUpdate(),
        mutationFn({ rules }: UpdateScoringConfigVariables) {
            return salesApiService.signals.updateScoringConfig(configType, rules);
        },
    });
};

export default useUpdateScoringConfigMutation;
